import { BlogList } from "../components/pages/blogList";

export function BlogListPage(){

    return(
        <>
            <BlogList />
        </>
    );
}